<div>
  <ng-template #fileDetailPopover>
    <div *ngIf="file" class="w-400">
      <div class="row">
        <div class="col-xs-6 text-muted">{{ "EMPLOYEE_MANAGE.file_name" | translate }}</div>
        <div class="col-xs-6">{{ file?.filename }}</div>
      </div>
      <div class="row">
        <div class="col-xs-6 text-muted">{{ "EMPLOYEE_MANAGE.file_type" | translate }}</div>
        <div class="col-xs-6">{{ file?.filename.split(".").last().toUpperCase() }}</div>
      </div>
      <div class="row">
        <div class="col-xs-6 text-muted">{{ "EMPLOYEE_MANAGE.file_size" | translate }}</div>
        <div class="col-xs-6">{{ file?.size | gpByte }}</div>
      </div>
      <div class="row">
        <div class="col-xs-6 text-muted">{{ "EMPLOYEE_MANAGE.folder_name" | translate }}</div>
        <div class="col-xs-6">{{ file?.groupZone | translate }}</div>
      </div>
      <div class="row">
        <div class="col-xs-6 text-muted">{{ "EMPLOYEE_MANAGE.file_tag" | translate }}</div>
        <div class="col-xs-6">{{ file?.zone | translate }}</div>
      </div>
      <div class="row">
        <div class="col-xs-6 text-muted">{{ "EMPLOYEE_MANAGE.uploaded" | translate }}</div>
        <div class="col-xs-6">{{ file?.uploadDate | gpDate: {withTime: true} }}</div>
      </div>
      <div class="row">
        <div class="col-xs-6 text-muted">{{ "EMPLOYEE_MANAGE.last_modified" | translate }}</div>
        <div class="col-xs-6">{{ file?.updateDate | gpDate: {withTime: true} }}</div>
      </div>
      <div class="row">
        <div class="col-xs-6 text-muted">{{ "EMPLOYEE_MANAGE.owner" | translate }}</div>
        <div class="col-xs-6">{{ file?.initiatorName }}</div>
      </div>
    </div>
  </ng-template>
  <div *ngIf="report" class="b-report-page-left">
    <gp-modal size="lg" gp-modal="employee-detail" [hideHeader]="true" [form]="false" #employeeDisplayModal>
      <div class="gp-modal-body">
        <button class="close-button" (click)="employeeDisplayModal.close()">
          <i class="fa fa-light fa-times"></i>
        </button>
        <gp-employee-form [contractId]="contractId" [readOnly]="true"></gp-employee-form>
      </div>
      <div class="gp-modal-footer">
        <button type="button" test-id="closeBtn" class="btn dark-white p-x-md" (click)="employeeDisplayModal.close()">
          {{ "FORMS.enclose" | translate }}
        </button>
      </div>
    </gp-modal>

    <div class="flex w-100">
      <div #reportFilterSidePanel class="report-filter-side-panel shadow" [ngStyle]="{ width: resizeLeft + 'px' }">
        <button class="toggle-button" (click)="toggleSidePanel()">
          <i aria-hidden="true"
             class="fa fa-light text-secondary"
             [ngClass]="{ 'fa-angle-double-left': !isSidePanelCollapsed, 'fa-angle-double-right': isSidePanelCollapsed }">
          </i>
        </button>
        <div class="config-panels">
          <div class="collapse-panel" (click)="toggleSidePanel()" [attr.data-hidden]="!isSidePanelCollapsed">
            <div class="verticaltext">
              {{ "REPORTS.settings" | translate }}
            </div>
          </div>
          <div #reportTopCardRef>
            <gp-report-top-card
              [attr.data-hidden]="isSidePanelCollapsed"
              [reportsTree]="reportsTree"
              [report]="report"
              [user]="user"
              [isPreviewLoaded]="isPreviewLoaded"
              (updateReportList)="onUpdateReportList()"
              (languageChange)="setLanguage($event)"
              (resetReport)="getReports()"
              (setEnabledFields)="onSetEnabledFields($event)">
            </gp-report-top-card>
          </div>
          <div class="filters-and-columns"
               [style.height]="'calc(100vh + ' + resizeFilterColumnBlockHeight + 'px)'"
               [attr.data-hidden]="isSidePanelCollapsed">
            <div *ngIf="reportsService.isFieldsLoaded && activeReportId"
                 class="text-center disabledDetails gd-overlay"
                 [ngStyle]="{ width: resizeLeft + 'px' }">
              <i aria-hidden="true" class="fa fa-light fa-spinner fa-spin vertical-alight"></i>
            </div>
            <div class="box card-box m-b-0 filters">
              <div class="box-header ribbon">
                <h3>{{ "TOOLTIPS.filters" | translate }}
                  <span *ngIf="report.filters.length > 0" class="m-l-xs">({{ report.filters.length }})</span>
                </h3>
              </div>
              <div class="box-body p-b-xs">
                <gp-report-filter
                  [attr.data-hidden]="isSidePanelCollapsed"
                  [isOpen]="report?.filters.length < 10"
                  [report]="report"
                  [enabledFields]="enabledFields"
                  [showAndOperatorText]="false">
                </gp-report-filter>
              </div>
            </div>
            <gp-report-result
              [attr.data-hidden]="isSidePanelCollapsed"
              [report]="report"
              [enabledFields]="enabledFields">
            </gp-report-result>
          </div>
        </div>
      </div>
      <div class="report-preview-grid white" [style.width]="'calc(100% - ' + resizeLeft + 'px)'">
        <div class="resize height"
             [ngStyle]="{
            left: reportFilterSidePanel.offsetWidth + reportFilterSidePanel.getBoundingClientRect().left + 'px'
          }"
             #resizeLine>
        </div>

        <div class="box card-box table-box shadow">
          <div class="box-header">
            <h3>
              <span *ngIf="previewData && !isEmptyTable">
                {{ "REPORTS.total" | translate }}: {{ totalItemsDisplay }}
              </span>

              <label class="checkbox checkbox-inline m-l-sm group-sorted-label"
                     *ngIf="previewData && !isEmptyTable && !aiAnalyticsEnabled"
                     [class.disabled]="isGroupSortedItemsDisabled"
                     [tooltip]="groupSortedItemsTooltip"
                     container="body"
                     placement="bottom">
                <input type="checkbox" [(ngModel)]="groupSortedItems" [disabled]="isGroupSortedItemsDisabled" />
                {{ "REPORTS.group_sorted_items" | translate }}
              </label>

              <div class="pull-right">
                <label class="ai-analytics-toggle m-r-sm"
                       *ngIf="previewData && !isEmptyTable"
                       test-id="aiAnalyticsToggle">
                  <span class="ui-switch ui-switch-md v-m">
                    <input type="checkbox"
                           [checked]="aiAnalyticsEnabled"
                           [disabled]="previewLoading"
                           (change)="toggleAiAnalytics($any($event.target).checked)" />
                    <em></em>
                  </span>
                  <i class="fa-light fa-wand-magic-sparkles ai-analytics-icon v-m m-l-xs" aria-hidden="true"></i>
                  <span class="v-m">{{ "REPORTS.ai_analytics" | translate }}</span>
                </label>
                <button type="button"
                        class="btn btn-sm btn-fill-primary m-r-xs results-btn"
                        [attr.test-id]="'generate-preview' | gpTestId: 'report-top-card'"
                        [disabled]="isPreviewBtnDisabled || previewLoading"
                        (click)="initPreview()">
                  <span *ngIf="previewLoading"><i class="fa fa-spinner fa-spin" aria-hidden="true"></i></span>
                  <span *ngIf="!previewData && !previewLoading"><i class="fa fa-eye p-r-xs" aria-hidden="true"></i></span>
                  <span *ngIf="!previewData && !previewLoading">{{ "REPORTS.view_results" | translate }}</span>
                  <span *ngIf="previewData && !previewLoading"><i class="fa fa-refresh p-r-xs" aria-hidden="true"></i></span>
                  <span *ngIf="previewData && !previewLoading">{{ "REPORTS.refresh_results" | translate }}</span>
                </button>

                <div class="btn-group dropdown m-r-xs export-dropdown">
                  <button class="btn btn-sm btn-outline-default dropdown-toggle"
                          [disabled]="isExportBtnDisabled || exportInProgress"
                          [attr.test-id]="'export-preview' | gpTestId: 'report-top-card'"
                          (click)="exportDropdownCollapsed = !exportDropdownCollapsed"
                          (click-outside)="exportDropdownCollapsed = false">
                    <span *ngIf="exportInProgress"><i class="fa fa-spinner fa-spin" aria-hidden="true"></i></span>
                    <span *ngIf="!exportInProgress"><i class="fa fa-file-export" aria-hidden="true"></i></span>
                    {{ "REPORTS.export" | translate }}
                  </button>
                  <div class="dropdown-menu pull-right" [collapse]="!exportDropdownCollapsed">
                    <a class="dropdown-item"
                       [class.disabled]="isExportBtnDisabled || exportInProgress"
                       (click)="!isExportBtnDisabled && !exportInProgress && onExport(); exportDropdownCollapsed = false">
                      <span aria-hidden="true" class="fa fa-light fa-file-excel dropdown-icon"></span>
                      {{ "REPORTS.export_excel" | translate }}
                    </a>
                    <span [tooltip]="isCsvExportTooltipVisible ? ('REPORTS.view_and_load_all_the_results_to_enable_CSV_export' | translate) : ''"
                          container="body">
                    <a class="dropdown-item"
                       [class.disabled]="!isPreviewLoaded || isEmptyTable || !previewData || hasMoreData || groupSortedItems"
                       (click)="isPreviewLoaded && !isEmptyTable && previewData && !groupSortedItems && onExportCsv(); exportDropdownCollapsed = false">
                      <span aria-hidden="true" class="fa fa-light fa-file-csv dropdown-icon"></span>
                      {{ "REPORTS.export_csv" | translate }}
                    </a>
                    </span>
                  </div>
                </div>
              </div>
            </h3>
          </div>
          <div class="box-body">
            <div *ngIf="isInitialState || isEmptyTable" class="vertical-alight">
              <div *ngIf="isInitialState && !isEmptyTable" class="m-a">
                <gp-illustrated-message
                  [width]="'75%'"
                  [type]="'SEARCH'"
                  [text]="'REPORTS.initial_state'">
                </gp-illustrated-message>
              </div>
              <div *ngIf="isEmptyTable" class="m-a">
                <gp-illustrated-message [width]="'75%'" [text]="'REPORTS.no_results'"></gp-illustrated-message>
              </div>
            </div>
            <gp-hot-table
              class="hot-table"
              *ngIf="previewData && !isEmptyTable && !groupSortedItems && !aiAnalyticsEnabled"
              [colHeaders]="previewData.headers"
              [nestedHeaders]="previewData.nestedHeaders"
              [columns]="previewData.columns"
              [options]="previewData.options"
              [data]="previewData.data"
              [tooltipHeaders]="previewData.tooltipHeaders"
              [width]="previewData.containerWidth">
            </gp-hot-table>
            <gp-report-summary-row
              *ngIf="previewData && !isEmptyTable && !groupSortedItems && allRecordsLoaded && !previewLoading && !aiAnalyticsEnabled"
              [columns]="summaryColumns"
              [data]="summaryData"
              [hotInstance]="hotTable?.table">
            </gp-report-summary-row>
            <div class="grouped-results-container" *ngIf="groupedDisplayItems && groupSortedItems && !aiAnalyticsEnabled">
              <div class="grouped-results-list">
                <gp-report-grouped-result-item
                  *ngFor="let groupItem of groupedDisplayItems; trackBy: trackByGroupItem"
                  [groupItem]="groupItem"
                  [previewData]="previewData"
                  [sortConfig]="currentSortConfigs"
                  [fileDetailPopover]="fileDetailPopover"
                  (employeeDetailsRequested)="showEmployeeDetails($event)">
                </gp-report-grouped-result-item>
              </div>
            </div>
            <gp-report-analytics
              *ngIf="aiAnalyticsEnabled && analyticsRequest && previewData && !isEmptyTable"
              [request]="analyticsRequest"
              [refreshToken]="analyticsRefreshToken">
            </gp-report-analytics>
            <footer gp-sticky="bottom">
              <div class="p-t-md" *ngIf="!previewLoading && totalItemsDisplay && !aiAnalyticsEnabled">
                <div class="row">
                  <div class="col-sm-4 text-left">
                    <span class="load-more-wrapper" [class.disabled]="isLoadingMore || !hasMoreData">
                      <a
                        href="#"
                        class="btn btn-plain-default load-more-link"
                        test-id="loadMoreButton"
                        [class.disabled]="isLoadingMore || !hasMoreData"
                        (click)="loadMoreData(); $event.preventDefault()">
                        {{ (isLoadingMore ? 'COMMON.loading' : 'DASHBOARD.load_more') | translate }}
                      </a>
                    </span>
                  </div>
                  <div class="col-sm-4 text-center">
                    <span test-id="loadedRecordsInfo">
                      {{ 'REPORTS.showing_of_items' | translate: {
                        lastItem: loadedItemsCount,
                        totalItems: totalItemsDisplay
                      } }}
                    </span>
                  </div>
                  <div class="col-sm-4"></div>
                </div>
              </div>
            </footer>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
